import { Outlet } from "react-router-dom";
import BootstrapScreen from "../../../auth/BootstrapScreen";
import useAuthBootstrap from "../../../auth/useAuthBootstrap";
import { useOnboardingGateRedirect } from "../../onboarding/OnboardingGate";
import { useTrainRecovery } from "./trainIdentity";

// `/train/*` state matrix (§9.8). Normal routes keep BootstrapGate; TRAIN
// comes here instead so a locally recoverable workout stays reachable while
// bootstrap is resolving, unavailable or anonymous.
//   local identity          -> the TRAIN shell, from local data, no OnboardingGate
//   authenticated           -> today's OnboardingGate semantics, then TRAIN
//   resolving / unavailable -> BootstrapScreen, exactly as BootstrapGate
//   anonymous               -> today's anonymous routing, once the probe has
//                              answered (it could still unlock the local shell)
//
// Both TRAIN branches render the same keyed <Outlet>, so the subtree (MainLayout
// and the TRAIN screens) survives a same-user local -> authenticated change
// with its editor and lock, and is remounted whenever the effective user
// changes: another user's execution never stays mounted or in memory.
export default function ExecutionShellGate() {
  const bootstrap = useAuthBootstrap();
  const recovery = useTrainRecovery();
  const identity = recovery?.identity || null;
  const onboardingRedirect = useOnboardingGateRedirect();

  if (identity?.mode === "local") {
    return <Outlet key={identity.userId} />;
  }

  if (
    bootstrap.status === "resolving" ||
    bootstrap.status === "unavailable" ||
    (bootstrap.status === "anonymous" && recovery?.probePending)
  ) {
    return (
      <BootstrapScreen
        status={bootstrap.status === "unavailable" ? "unavailable" : "resolving"}
        presentation={bootstrap.presentation}
        onRetry={bootstrap.retry}
      />
    );
  }

  if (onboardingRedirect) return onboardingRedirect;

  return <Outlet key={identity?.userId || ""} />;
}
